var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDataCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(-11143.333 -3294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 60,
    height: 60,
    transform: "translate(11143.333 3294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M11192.85,3318.549h-39.033a5.03,5.03,0,0,1-4.979-5.068v-6.726a5.029,5.029,0,0,1,4.979-5.068h39.033a5.029,5.029,0,0,1,4.979,5.068v6.726A5.03,5.03,0,0,1,11192.85,3318.549Zm-39.033-13.862a2.027,2.027,0,0,0-1.979,2.068v6.726a2.028,2.028,0,0,0,1.979,2.068h39.033a2.028,2.028,0,0,0,1.979-2.068v-6.726a2.027,2.027,0,0,0-1.979-2.068Zm4.605,6.957h13.385a1.526,1.526,0,1,0,0-3.052h-13.385a1.526,1.526,0,0,0,0,3.052Zm21.57,0h1.525a1.526,1.526,0,0,0,0-3.052h-1.525a1.526,1.526,0,1,0,0,3.052Zm6.9,0h1.526a1.526,1.526,0,1,0,0-3.052h-1.526a1.526,1.526,0,0,0,0,3.052Zm5.962,20.788h-39.033a5.03,5.03,0,0,1-4.979-5.068v-6.727a5.03,5.03,0,0,1,4.979-5.068h39.033a5.03,5.03,0,0,1,4.979,5.068v6.727A5.03,5.03,0,0,1,11192.85,3332.432Zm-39.033-13.863a2.027,2.027,0,0,0-1.979,2.068v6.727a2.027,2.027,0,0,0,1.979,2.068h39.033a2.027,2.027,0,0,0,1.979-2.068v-6.727a2.027,2.027,0,0,0-1.979-2.068Zm4.605,6.957h13.385a1.525,1.525,0,1,0,0-3.051h-13.385a1.525,1.525,0,1,0,0,3.051Zm21.57,0h1.525a1.525,1.525,0,1,0,0-3.051h-1.525a1.525,1.525,0,1,0,0,3.051Zm6.9,0h1.526a1.525,1.525,0,1,0,0-3.051h-1.526a1.525,1.525,0,1,0,0,3.051Zm5.962,20.787h-39.033a5.029,5.029,0,0,1-4.979-5.067v-6.726a5.03,5.03,0,0,1,4.979-5.068h39.033a5.03,5.03,0,0,1,4.979,5.068v6.726A5.029,5.029,0,0,1,11192.85,3346.313Zm-39.033-13.861a2.028,2.028,0,0,0-1.979,2.068v6.726a2.027,2.027,0,0,0,1.979,2.067h39.033a2.027,2.027,0,0,0,1.979-2.067v-6.726a2.028,2.028,0,0,0-1.979-2.068Zm4.605,6.957h13.385a1.526,1.526,0,1,0,0-3.052h-13.385a1.526,1.526,0,0,0,0,3.052Zm21.57,0h1.525a1.526,1.526,0,0,0,0-3.052h-1.525a1.526,1.526,0,1,0,0,3.052Zm6.9,0h1.526a1.526,1.526,0,1,0,0-3.052h-1.526a1.526,1.526,0,0,0,0,3.052Z",
    fill: "#18c99d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataCenter);
export default __webpack_public_path__ + "static/media/icon-data-center.e4fb4ccfc6cf8018bb510cd52fbcfdd7.svg";
export { ForwardRef as ReactComponent };